var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"onload":_vm.fullName}},[_vm._v(_vm._s(_vm.full_name))])
}
var staticRenderFns = []

export { render, staticRenderFns }